import { render } from "./TechnicalDocs.vue?vue&type=template&id=26f7bfc7"
import script from "./TechnicalDocs.vue?vue&type=script&lang=js"
export * from "./TechnicalDocs.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__